export const COVERAGE_AREA_TYPE = {
  DEALER_MAP: "DealerMap",
  DEALER_STORE: "DealerStore",
  DRIVER_STORE: "DriverStore",
} as const;

export type CoverageAreaType =
  (typeof COVERAGE_AREA_TYPE)[keyof typeof COVERAGE_AREA_TYPE];

export function isDealerMapType(type?: string): boolean {
  return type === COVERAGE_AREA_TYPE.DEALER_MAP;
}

export function isDealerStoreType(type?: string): boolean {
  return type === COVERAGE_AREA_TYPE.DEALER_STORE;
}

export function isDriverStoreType(type?: string): boolean {
  return type === COVERAGE_AREA_TYPE.DRIVER_STORE;
}

export function isStorePortariaType(type?: string): boolean {
  return isDealerStoreType(type) || isDriverStoreType(type);
}
